import { jsx as _jsx } from "react/jsx-runtime";
import DateFieldDetail from "./detail";
import { FieldViewType } from "../viewType";
/**
 * Format de date par défaut
 */
export var defaultDateFormat = "DD/MM/YYYY";
/** <b>Composant en mode consultation/detail d'un champ de type Date</b>*/
export default function DateFieldList(_a) {
    var fieldName = _a.fieldName, record = _a.record, _b = _a.format, format = _b === void 0 ? defaultDateFormat : _b;
    return (_jsx(DateFieldDetail, { fieldName: fieldName, record: record, format: format, viewType: FieldViewType.DETAIL }));
}
